import * as React from "react";
import * as S from "./style";
import loadingGif from "../../../assets/loading.gif";
import { useLanguage } from "../../../contexts/LanguageContext";

const MIN_DOTS = 1;
const MAX_DOTS = 3;
const TICK_MS = 500;

export default function SummaryLoading() {
  const { t } = useLanguage();
  const [dots, setDots] = React.useState(MIN_DOTS);
  const directionRef = React.useRef(1);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => {
        const next = prev + directionRef.current;
        if (next >= MAX_DOTS) {
          directionRef.current = -1;
          return MAX_DOTS;
        }
        if (next <= MIN_DOTS) {
          directionRef.current = 1;
          return MIN_DOTS;
        }
        return next;
      });
    }, TICK_MS);
    return () => clearInterval(interval);
  }, []);

  return (
    <S.Wrapper>
      <S.LoadingImage src={loadingGif} alt="" />
      <S.LoadingText variant="caption">
        {t('copilot.summaryLoading')}
        <S.Dots>{".".repeat(dots)}</S.Dots>
      </S.LoadingText>
    </S.Wrapper>
  );
}
